define('models/StoreLocationModel',['underscore','jquery','backbone','app','site_vars','ObjectModel',
    'mapbox',
    'mapboxGL',
    'LocalStorage',
    'models/StoreCollection',
    'string'
], function (_,$,Backbone,app,site_vars,ObjectModel,
             mapbox,
             mapboxGL,
             LocalStorage,
             StoreCollection,
             S
) {

    var // geocoder,
        // computeDistanceBetween,
        LngLat,
        LngLatBounds,
        turf;

    function InitMapboxGL(callback){
        // init Google Classes refs
        mapboxGL.init(function(mapboxGLJS, turfJS){
            turf = turfJS;
            window.turf = turf;
            window.LngLat = LngLat;
            window.LngLatBounds = LngLatBounds;
            window.mapboxGLJS = mapboxGLJS;
            LngLat = mapboxGLJS.LngLat;
            LngLatBounds = mapboxGLJS.LngLatBounds;
            if(callback) callback();
        },function(){

        });
    }

    var countryStorePolygon = [];
    var matchingLatLng = [];

    var resultBounds, // boite contenant les résultats
        resultPolygon, // Polygone contenant les résultats
        matchingStores, // magasin correspondant à la recherche
        matchingRadius; // 20 kk;

    function ResetResultVars(){
        resultBounds = new LngLatBounds(); // boite contenant les résultats
        matchingStores = new StoreCollection(); // magasin dans le radius
        matchingRadius = 20; // 20 km
    }

    function traceBoundingBox(store) {
        try {
            var storeLng = store.getLongitude(),
                storeLat = store.getLatitude(),
                storePosition = [storeLng,storeLat];
            matchingLatLng.push(storePosition);
        } catch (err) {
        }
    }

    function convertMatchinLatLngToResults(){
        var resultBoundsBbox = turf.bbox(turf.helpers.multiPoint(matchingLatLng));
        resultBounds = new LngLatBounds(resultBoundsBbox);
        resultPolygon = turf.bboxPolygon(resultBoundsBbox);
    }

    var StoreLocationModel = {
        initialize:function(options){
            var model = this,
                type,
                location = options.search ? options.search : false;

            countryStorePolygon = [];
            matchingLatLng = [];

            if(location){
                model.id = S(location).slugify().s;
            }

            model.location = location || '';

            if (options.type === 'store'){
                type = 'store';
            } else if (options.shop) {
                type = 'shop';
            } else if(options.postcode){
                type = 'postcode';
            } else if(options.state){
                type = 'state';
            } else if(options.city){
                type = 'city';
            } else if(options.bounds){
                type = 'bounds';
                model.id = getIdFromBounds(options.bounds);
            } else if(options.position){
                type = 'position';
                model.id = S(options.position).trim().s;
            } else {
                // si la recherche est vide, pas besoin de faire une requête !
                type = 'all';
            }
            model.set('type',type);
            var getAllFrom = $.proxy(model.getAllFrom,model);
            switch(type){
                case 'store': getAllFrom(model.shopCondition, options); break; //
                case 'shop': getAllFrom(model.shopCondition, options); break; // shop -> page atterissage
                case 'state': getAllFrom(model.stateCondition, options); break;
                case 'postcode': getAllFrom(model.postcodeCondition, options); break;
                case 'city': getAllFrom(model.cityCondition, options); break;
                case 'all': getAllFrom(model.countryCondition, options); break;
                case 'bounds': model.searchInBounds(options); break;
                case 'position': model.searchAroundPosition(options); break;
                // case 'search': model.fetch(); break;
            }
        },
        searchInBounds:function(options){
            var model = this,
                bounds = options.bounds,
                bbox = new LngLatBounds(bounds);

            ResetResultVars();
            resultBounds = bounds;
            resultPolygon = turf.bboxPolygon(resultBounds);
            function storeInBounds(store,i) {
                try {
                    var lat = store.getLatitude(),
                        lng = store.getLongitude(),
                        storePosition = [lng, lat];
                    var storePoint = turf.helpers.point(storePosition);

                    if (turf.booleanPointInPolygon(storePoint, resultPolygon)) {
                        matchingStores.push(store);
                    }

                } catch (err) {
                }

            }
            app.getStores().each(storeInBounds);
            model.setResults();
        },
        searchAroundPosition:function(options){
            var model = this,
                allStores = app.getStores(),
                lng = options.position[0],
                lat = options.position[1],
                resultPosition = [lng,lat];

            ResetResultVars();
            resultBounds = new LngLatBounds([lng,lat,lng,lat]);

            function AroundSearch(closestRadius) {
                var closestStores = [];
                matchingLatLng = [];
                allStores.each(function (store) {
                    var storeLng = store.getLongitude(),
                        storeLat = store.getLatitude(),
                        storeDist = NaN,
                        storePosition = [storeLng, storeLat];

                    if(!(_.isNaN(storeLat) || _.isNaN(storeLng))){
                        storeDist = turf.distance(storePosition, resultPosition) || 0;
                    }

                    if (storeDist < closestRadius) {
                        closestStores.push(store);
                    }
                    store.set('distance_search', storeDist);
                });
                closestStores = _(closestStores).sortBy(function(store){
                   return store.get('distance_search');
                }).slice(0,3);
                // on prend les 3 boutiques les plus proches seulement
                if(closestStores.length>0){
                    _(closestStores).each(function(s){
                        traceBoundingBox(s);
                        matchingStores.push(s);
                    });
                }
                return closestStores;
            }
            var aroundStores = AroundSearch(50);
            if(aroundStores.length<2){
                aroundStores = AroundSearch(100);
            }
            if(aroundStores.length) {
                convertMatchinLatLngToResults();
            }else{
                model.set('type', 'empty');
            }
            model.setResults();

        },
        setResults:function(){
            var model = this;
            //
            model.set({
                resultBounds:resultBounds,
                matchingStores:matchingStores
            });
            model.trigger('sync', model);
        },
        getResultBounds:function(){
            return this.get('resultBounds');
        },
        // boutiques associées à la recherche
        getMatchingStores:function(){
            return this.get('matchingStores');
        },
        // boutique la plus proche
        getClosestStore:function(){
            return this.get('closestStore');
        },
        isEmpty:function(){
            return this.get('type') === 'empty';
        },
        getAllFrom: function(callback, options) {
            var model = this;
            ResetResultVars();
            app.getStores().each(function(store) {
                if (callback(store, options)) {
                    traceBoundingBox(store)
                    matchingStores.push(store);
                }
            });
            if(matchingStores.length>0) {
                convertMatchinLatLngToResults();
            }else{
                model.set('type', 'empty');
            }
            model.setResults();
        },
        shopCondition: function(store, options) {
            return store.id === options.shop.id
        },
        stateCondition: function(store, options) {
            return _.contains(options.state.get('stores'), store.id);
        },
        postcodeCondition: function(store, options) {
            var postcode = options.postcode;
            return _.contains(store.getPostcodes(), postcode.id) || store.isPostcode(postcode.id);
        },
        cityCondition: function(store, options) {
            var city = options.city;
            return _.contains(city.get('stores'), store.id);
        },
        countryCondition: function(store, options) {
            return true
        },
    },

    StoreLocationModel = ObjectModel
            .extend(LocalStorage)
            .extend(StoreLocationModel);

    function getIdFromBounds(bounds){
        return S(bounds).slugify().s;
    };
    StoreLocationModel.getIdFromBounds = getIdFromBounds;

    StoreLocationModel.InitMapboxGL = InitMapboxGL

    return StoreLocationModel;

});

